import createDataContext from "./createDataContext";
import axios from 'axios'


const authReducer = (state, action) => {
    switch (action.type) {
        case 'MALARIA':
            return {...state, token:action.payload}
        case 'LASSA':
          return {...state, token: null}
        case 'FETCH_MALARIA':
            return {...state, malaria: action.payload}
        case 'FETCH_LASSA':
            return {...state, lassa:action.payload}
      default:
        return state;
    }
};

const fetchMalaria = (dispatch) => async () => {
    await axios.get('https://vigrant-vitale.herokuapp.com/api/m')
    .then(res => {
        dispatch({
            type:'FETCH_MALARIA',
            payload: res.data
        })
    })
    .catch(e => console.log(e.message))
}

const fetchLassa = (dispatch) => async () => {
    await axios.get('https://vigrant-vitale.herokuapp.com/api/l')
    .then(res => {
        dispatch({
            type:'FETCH_LASSA',
            payload: res.data
        })
    })
}

const updateMalaria = dispatch => async ({total, active, recovered, deaths, onSuccess}) => {
    axios.post('https://vigrant-vitale.herokuapp.com/api/malaria', {total, active, recovered, deaths, name:'malaria'})
    .then((res) => {
        dispatch({
            type:'FETCH_MALARIA',
            payload: res.data
        })
        window.location.reload(false)
        onSuccess()
    })
}

const updateLassa = dispatch => async ({total, active, recovered, deaths, onSuccess}) => {
    axios.post('https://vigrant-vitale.herokuapp.com/api/lassa', {total, active, recovered, deaths, name:'lassa'})
    .then(r => {
        dispatch({
            type:'FETCH_LASSA',
            payload: r.data
        })
        window.location.reload(false);
        onSuccess()
        // console.log(r.data)
    })
    .catch(err => console.log(err.message))
}



  export const { Provider, Context } = createDataContext(
    authReducer,
    { updateMalaria, updateLassa, fetchMalaria, fetchLassa },
    { token: null, errorMessage: "", error: "", malaria: "" }
  );